import { Component } from '@angular/core';
import { CadastreMapComponent } from './cadastre-map/cadastre-map.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CadastreMapComponent],
  template: '<app-cadastre-map />'
})
export class AppComponent {}
